import React from 'react';
import { Alert } from 'reactstrap';

const AddBrand = ({ brand, handleChange, addNewBrand, error, alert, dismiss, disableValue, alertMsg }) => {
  return (
    <React.Fragment>
      <div>
        <Alert className="badge-content" color="success" isOpen={alert} toggle={dismiss}>
          {alertMsg}
        </Alert>
        <div className="row form-group">
          <div className="col-sm-1" />
          <div className="col-sm-3">
            <label for="exampleInputEmail1">Brand Name</label>
          </div>
          <div className="col-sm-7">
            <input type="text" class="form-control" id="brand" name="brand" placeholder="Enter Brand" onChange={handleChange} value={brand} />
          </div>
          <div className="col-sm-1" />
        </div>
        <div className="row form-group">
          <div className="col-sm-4" />
          <span className="modal-error-show">{error}</span>
        </div>

        <div className="row form-group">
          <div className="col-sm-4" />
          <div className="col-sm-4">
            <button type="button" class="btn btn-primary" disabled={disableValue} onClick={addNewBrand}>
              Add Brand
            </button>
          </div>
          <div className="col-sm-4" />
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddBrand;
